/**
 * linkedinShare
 *
 * Helpers pra construir URLs do LinkedIn:
 *  - buildLinkedInUrl: Add to Profile (certificacao oficial)
 *  - buildShareWebUrl: compartilhar como post no feed
 *
 * Doc oficial: https://addtoprofile.linkedin.com/
 */

/**
 * Constroi URL de "Add to Profile" do LinkedIn.
 * O usuario clica e vai pro LinkedIn ja preenchido pra adicionar no perfil.
 */
export function buildLinkedInUrl(cert, origin) {
  if (!cert || !cert.certificateCode) return null;

  var date = new Date(cert.completionDate || Date.now());
  var year = date.getUTCFullYear();
  var month = date.getUTCMonth() + 1;

  var courseName = cert.courseName || cert.classroomName || 'Certificado de Conclusão';
  var systemName = 'SuperGeeks';

  // Tenta pegar do app config dinamicamente
  try {
    if (typeof window !== 'undefined' && window.app && window.app.state && window.app.state.confs && window.app.state.confs.systemName) {
      systemName = window.app.state.confs.systemName;
    }
  } catch (e) {}

  var baseOrigin = origin;
  if (!baseOrigin && typeof window !== 'undefined' && window.location && window.location.origin) {
    baseOrigin = window.location.origin;
  }
  if (!baseOrigin) baseOrigin = '';

  var certUrl = baseOrigin + '/certificate/verify/' + cert.certificateCode;
  var name = courseName + ' - ' + systemName;

  var params = [
    'startTask=CERTIFICATION_NAME',
    'name=' + encodeURIComponent(name),
    'organizationName=' + encodeURIComponent(systemName),
    'issueYear=' + year,
    'issueMonth=' + month,
    'certUrl=' + encodeURIComponent(certUrl),
    'certId=' + encodeURIComponent(cert.certificateCode)
  ];

  return 'https://www.linkedin.com/profile/add?' + params.join('&');
}

/**
 * Constroi URL pra compartilhar como post no feed.
 */
export function buildShareWebUrl(url) {
  if (!url || typeof url !== 'string' || !url.trim()) return null;
  return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
}

export default { buildLinkedInUrl, buildShareWebUrl };
